import Settings from '../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 40,
    TINT: 0xffffff,
};

const EVENTS = {
    START: 'boss_timer_start',
    STOP: 'boss_timer_stop',
    EXPIRED: 'boss_timer_expired',
};

const TICK_RATE = 1000;

export default class BossTimer extends Phaser.GameObjects.Container {
    private label!: Phaser.GameObjects.BitmapText;
    private ticker: Phaser.Time.TimerEvent | null = null;
    private seconds: number = 0;

    constructor(scene: Phaser.Scene) {
        let x = scene.cameras.main.centerX;
        let y = 200;
        super(scene, x, y);

        this.setupLabel();
        this.setupListeners();

        this.hide();
    }

    static get EVENTS() {
        return EVENTS;
    }

    setupLabel() {
        this.label = this.scene.add.bitmapText(0, 0, LABEL.FONT, '00:00', LABEL.SIZE);
        this.label.setTint(LABEL.TINT);
        this.label.setOrigin(0.5);
        this.add(this.label);
    }

    setupListeners() {
        this.scene.events.on(EVENTS.START, this.start, this);
        this.scene.events.on(EVENTS.STOP, this.stop, this);
    }

    start(seconds: number) {
        if (this.ticker) this.ticker.remove();
        this.seconds = seconds;

        this.show();

        this.ticker = this.scene.time.addEvent({
            delay: TICK_RATE,
            repeat: -1,
            callback: this.onTick,
            callbackScope: this,
        });
    }

    stop() {
        if (this.ticker) this.ticker.remove();

        this.hide();
    }

    onTick() {
        this.seconds--;
        this.formatTime();

        if (this.seconds === 0) {
            this.scene.events.emit(EVENTS.EXPIRED);
            this.stop();
            return;
        }
    }

    formatTime() {
        let string = new Date(this.seconds * 1000).toISOString().substring(14, 19);
        this.label.setText(string);
    }

    show() {
        this.formatTime();
        this.setVisible(true);
        this.setActive(true);
    }

    hide() {
        this.setVisible(false);
        this.setActive(false);
    }

    destroy() {
        this.scene.events.off(EVENTS.START, this.start, this);
        this.scene.events.off(EVENTS.STOP, this.stop, this);
    }
}
